import { render, staticRenderFns } from "./travelItinerary.vue?vue&type=template&id=d65fb9c8&scoped=true"
import script from "./travelItinerary.vue?vue&type=script&lang=js"
export * from "./travelItinerary.vue?vue&type=script&lang=js"
import style0 from "./travelItinerary.vue?vue&type=style&index=0&id=d65fb9c8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d65fb9c8",
  null
  
)

export default component.exports